import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../api/api';

export const fetchUnreadCount = createAsyncThunk('notification/fetchUnreadCount', async (_, { rejectWithValue }) => {
  try {
    const response = await api.get('/api/notifications/unread-count');
    return response.data.count;
  } catch (err) {
    return rejectWithValue(err.response?.data || err.message);
  }
});

const notificationSlice = createSlice({
  name: 'notification',
  initialState: {
    unreadCount: 0,
    loading: false,
    error: null,
  },
  reducers: {
    setUnreadCount: (state, action) => {
      state.unreadCount = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUnreadCount.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchUnreadCount.fulfilled, (state, action) => {
        state.unreadCount = action.payload;
        state.loading = false;
      })
      .addCase(fetchUnreadCount.rejected, (state, action) => {
        state.error = action.payload;
        state.loading = false;
      });
  },
});

export const { setUnreadCount } = notificationSlice.actions;
export default notificationSlice.reducer;
